var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompareButtonCompact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.799805C30.6039 0.799805 39.2002 9.39613 39.2002 20C39.2002 30.6039 30.6039 39.2002 20 39.2002C9.39613 39.2002 0.799805 30.6039 0.799805 20C0.799805 9.39613 9.39613 0.799805 20 0.799805Z",
    stroke: "black",
    strokeOpacity: 0.25,
    strokeWidth: 1.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 15.5222C11 15.1371 11.1912 14.752 11.5497 14.5254L16.4255 11.2408C17.8118 10.312 19.2937 12.3054 17.9313 13.2342L16.2821 14.3442H27.7093C29.4063 14.3442 29.4063 16.7907 27.7093 16.7907H16.4016L17.9313 17.8101C19.3176 18.7389 17.8118 20.7323 16.4255 19.8036L11.5497 16.5189C11.1912 16.2924 11 15.9299 11 15.5222ZM11 24.538C11 23.8584 11.5736 23.3148 12.2907 23.3148H23.7179L22.0687 22.2048C20.7063 21.276 22.1882 19.2826 23.5744 20.2113L28.4503 23.496C28.7849 23.7225 29 24.1076 29 24.4927C29 24.8778 28.8088 25.2629 28.4503 25.4895L23.5744 28.7741C23.0008 29.1592 22.1882 29.046 21.7819 28.4796C20.8497 27.1431 22.714 26.3956 23.5983 25.7386H12.2907C11.5736 25.7613 11 25.195 11 24.538Z",
    fill: "black",
    fillOpacity: 0.88
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompareButtonCompact);
export default __webpack_public_path__ + "static/media/compare-button-compact.22665120f35e994a59062cd391197c65.svg";
export { ForwardRef as ReactComponent };